import wretch from 'wretch';
import config from '@/config';
import {AuthSession} from '@/data/models/auth-session';

const api = (path: string) => wretch().url(`${config.api.endpoint}${path}`);

export default class AuthDao {
  static login(email: string, password: string): Promise<AuthSession> {
    return api('/auth/login').post({email, password}).json();
  }

  static refresh(refreshToken: string): Promise<AuthSession> {
    return api('/auth/refresh').post({refreshToken}).json();
  }

  static logout(refreshToken: string): Promise<void> {
    return api('/auth/logout').post({refreshToken}).res().then(() => undefined);
  }

  static forgotPassword(email: string): Promise<void> {
    return api('/auth/forgot-password').post({email}).res().then(() => undefined);
  }

  static resetPassword(token: string, password: string): Promise<void> {
    return api('/auth/reset-password').post({token, password}).res().then(() => undefined);
  }
}
